// extracted by mini-css-extract-plugin
export default {"badge":"CartBadge_badge__wcVuZ"};